export const SPREADSHEET_FILE_EXTENSIONS = ['.xlsx', '.xlsm', '.xls', '.csv', '.tsv'] as const;

export const WORD_FILE_EXTENSIONS = ['.docx', '.doc'] as const;

export const TEXT_FILE_EXTENSIONS = ['.txt'] as const;

export const POWERPOINT_FILE_EXTENSIONS = ['.pptx', '.ppt'] as const;

export const IMAGE_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.jpe', '.jfif', '.png', '.bmp', '.webp', '.gif'] as const;

export const EMAIL_ATTACHMENT_IMAGE_FILE_EXTENSIONS = [
  ...IMAGE_FILE_EXTENSIONS,
  '.svg',
  '.tiff',
  '.tif',
] as const;

export const SUPPORTED_INGESTION_FILE_EXTENSIONS = [
  '.pdf',
  '.msg',
  '.eml',
  ...WORD_FILE_EXTENSIONS,
  ...POWERPOINT_FILE_EXTENSIONS,
  ...TEXT_FILE_EXTENSIONS,
  ...SPREADSHEET_FILE_EXTENSIONS,
  ...IMAGE_FILE_EXTENSIONS,
] as const;

export const SUPPORTED_UPLOAD_FILE_EXTENSIONS = [
  ...SUPPORTED_INGESTION_FILE_EXTENSIONS,
  '.zip',
] as const;

export const SUPPORTED_FILE_TYPES_STRING = SUPPORTED_INGESTION_FILE_EXTENSIONS.join(',');

export const SUPPORTED_UPLOAD_FILE_TYPES_STRING = SUPPORTED_UPLOAD_FILE_EXTENSIONS.join(',');

export const FILE_EXTENSION_CONTENT_TYPES: Record<string, string> = {
  '.msg': 'application/vnd.ms-outlook',
  '.eml': 'message/rfc822',
  '.pdf': 'application/pdf',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.doc': 'application/msword',
  '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.ppt': 'application/vnd.ms-powerpoint',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
  '.xls': 'application/vnd.ms-excel',
  '.csv': 'text/csv',
  '.tsv': 'text/tab-separated-values',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.jpe': 'image/jpeg',
  '.jfif': 'image/jpeg',
  '.png': 'image/png',
  '.bmp': 'image/bmp',
  '.webp': 'image/webp',
  '.gif': 'image/gif',
  '.txt': 'text/plain',
  '.zip': 'application/zip',
};

export function getContentTypeForExtension(extension: string | undefined | null): string {
  if (!extension) {
    return 'application/octet-stream';
  }

  const normalizedExtension = extension.startsWith('.')
    ? extension.toLowerCase()
    : `.${extension.toLowerCase()}`;

  return FILE_EXTENSION_CONTENT_TYPES[normalizedExtension] || 'application/octet-stream';
}
